import type { ReactNode } from 'react';
import { cn } from './cn';

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'rounded border border-crow-line-strong px-1.5 font-crow-mono text-crow-label leading-[18px] font-medium text-crow-text-3',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
